// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonRow_wrapper__GgELG","secondary":"ButtonRow_secondary__H2yDL","primary":"ButtonRow_primary__hpIp9"};